interface FooterProps {
    mode?: 'view' | 'share';
    roleTitle?: string;
}

const imagesUrlPrefix = window.location.origin;

export default function Footer({
    mode = 'view',
    roleTitle,
}: FooterProps): JSX.Element {
    return (
        <div id="footer">
            {mode === 'share' && (
                <div className="topFooterInfo">
                    <div id="poweredBy">
                        <img
                            src="%STATIC_FILES_PATH%/potree/resources/images/psp_small.png"
                            alt=""
                        ></img>{' '}
                        Powered by Point Share Plus
                    </div>
                </div>
            )}
            {roleTitle && (
                <div className="topFooterInfo">
                    <div id="permissionsFooter">Mode: {roleTitle}</div>
                </div>
            )}
            <div id="osmAttributionWrapper">
                <div id="osmAttribution">
                    <a
                        href="https://www.openstreetmap.org/copyright"
                        target="_blank"
                    >
                        © OpenStreetMap
                    </a>
                </div>
            </div>
            <div className="row" id="footer_status_bar">
                <div className="col left">
                    <div id="footer_left_row" className="row">
                        <div
                            id="footer_left_row_col_one"
                            className="col-7"
                        ></div>
                        <div id="footer_left_row_col_two" className="col"></div>
                    </div>
                </div>
                <div className="col center">
                    <span id="copyright_text"></span>
                    <a
                        id="copyright_link"
                        href="https://pointshareplus.com"
                        target="_blank"
                        style={{ display: 'none' }}
                    >
                        PointSharePlus
                    </a>
                </div>
                <div className="col right">
                    <div id="footer_right_row" className="row">
                        <div
                            id="footer_right_row_col_one"
                            className="col-4"
                            style={{ textAlign: 'left' }}
                        ></div>
                        <div id="footer_right_row_col_two" className="col">
                            {mode === 'view' ? (
                                <img
                                    id="footer_alert"
                                    data-toggle="popover"
                                    style={{
                                        width: 21,
                                        height: 21,
                                        display: 'none',
                                    }}
                                    src={`${imagesUrlPrefix}%STATIC_FILES_PATH%/potree/resources/icons/alarm-icon.png`}
                                />
                            ) : (
                                <>
                                    <a
                                        id="embed_fullscreen"
                                        style={{ display: 'none' }}
                                        target="_blank"
                                        title="Click here for more tools."
                                    >
                                        <img
                                            style={{ width: 21, height: 21 }}
                                            src={`${imagesUrlPrefix}%STATIC_FILES_PATH%/potree/resources/images/custom_menu/fullscreen.png`}
                                            alt=""
                                            title="Click here for more tools."
                                        />
                                        <span style={{ fontSize: 12 }}>
                                            {' '}
                                            More tools
                                        </span>
                                    </a>
                                    <img
                                        id="footer_alert"
                                        data-toggle="popover"
                                        style={{
                                            width: 21,
                                            height: 21,
                                            display: 'none',
                                        }}
                                        src={`${imagesUrlPrefix}%STATIC_FILES_PATH%/potree/resources/icons/alarm-icon.png`}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
